export function AxiosCreateClient(clientClass, axiosFactory) {
    var _a;
    var axiosInstance = axiosFactory.createInstance();
    return new clientClass((_a = axiosFactory.axiosConfig.baseURL) !== null && _a !== void 0 ? _a : '', axiosInstance);
}
